import { InitialStateSelector } from "./models";

export const selectUserConfigRoutes_MenuItems = (state: InitialStateSelector) =>
  state.userSetup.userConfig.routes.menuItems;
export const selectUserConfigRoutes_RenderItems = (
  state: InitialStateSelector
) => state.userSetup.userConfig.routes.renderItems;
export const selectUserConfigRoles = (state: InitialStateSelector) =>
  state.userSetup.userConfig.roles;
export const selectUserConfigListaTransportadoras = (
  state: InitialStateSelector
) => state.userSetup.userConfig.listaTransportadoras;
export const selectUserConfigView_Home = (state: InitialStateSelector) =>
  state.userSetup.userConfig.views.home;
export const selectUserConfigView_Edi = (state: InitialStateSelector) =>
  state.userSetup.userConfig.views.edi;
export const selectUserConfigView_Matriz = (state: InitialStateSelector) =>
  state.userSetup.userConfig.views.matriz;
export const selectUserConfigView_Comprovantes = (
  state: InitialStateSelector
) => state.userSetup.userConfig.views.comprovantes;
export const selectUserConfigView_Ocorrencias = (state: InitialStateSelector) =>
  state.userSetup.userConfig.views.configuracoes.ocorrencias;
export const selectUserConfigViewConfig_Variaveis = (
  state: InitialStateSelector
) => state.userSetup.userConfig.views.configuracoes.variaveis;
export const selectUserConfigViewConfig_Transportadoras = (
  state: InitialStateSelector
) => state.userSetup.userConfig.views.configuracoes.transportadoras;
export const selectUserConfigViewConfig_CamposMatriz = (
  state: InitialStateSelector
) => state.userSetup.userConfig.views.configuracoes.camposDaMatriz;
export const selectUserAllowedRoutes = (
  state: InitialStateSelector
) => state.userSetup.userConfig.routes.allowedRoutes;
export const selectUserIsJuridico = (
  state: InitialStateSelector
) => state.userSetup.userConfig.isJuridico;
